export enum ESubscriptionResponseResult {
    SUCCESS = 'success',
    RE_CAPTCHA = 'reCAPTCHA',
}
